import { render, staticRenderFns } from "./TenantsAvatar.vue?vue&type=template&id=4f8a5c26&"
import script from "./TenantsAvatar.vue?vue&type=script&lang=js&"
export * from "./TenantsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports